module.exports = __webpack_public_path__ + "static/media/captcha.c479dfa2.png";